import React from 'react';
import { GenerateOutlineModal } from './generate_outline_modal';
import { ReviseOutlineModal } from './revise_outline_modal';

const SectionAiButtons = ({
    titleText,
    bodyText,
    setTitleText,
    setBodyText,
    setEvent,
    updateTitleContent,
    updateTextContent,
    event,
  }) => {
  
    return (
      <section id="ai_buttons">
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 bg-gray">
            <div className="d-flex align-items-center">
              <div className="d-flex flex-column text-start mr-3">
                <h6 className="text-fw-bold mt-3">
                  AIを使ってイベントをつくろう！
                </h6>
                <p className="text-gray text-fz-12px">
                  つなげーとが持つ膨大なデータから、成功確率の高いイベントをAIが作成補助します。
                </p>
              </div>
              <img
                src="/img/ai_image.png"
                alt="AIアイコン"
                className="img-fluid mt-2 mb-2"
                style={{ maxHeight: '70px' }}
              />
            </div>
            <div className="row justify-content-between align-items-center">
              <div className="col-8 mr-0 pr-0">
                <p className="text-fw-bold text-fz-14px">
                  1.一言テーマから自動作成
                </p>
                <p className="text-gray text-fz-12px">
                  「〇〇したい」を入力するだけで、タイトルと説明文を自動生成します。
                </p>
              </div>
              <div className="col-4 d-flex justify-content-center mx-0 px-0">
                <GenerateOutlineModal
                  onAcceptEventTitle={(newTitle) => {
                    setEvent((prev) => ({ ...prev, title: newTitle }));
                    setTitleText(newTitle);
                    updateTitleContent?.(newTitle);
                  }}
                  onAcceptEventBody={(newBody) => {
                    setBodyText(newBody);
                    updateTextContent?.(newBody);
                  }}
                />
              </div>
            </div>
            <div className="row justify-content-between align-items-center">
              <div className="col-8 mr-0 pr-0">
                <p className="text-fw-bold text-fz-14px">
                  2.タイトル・本文を添削
                </p>
                <p className="text-gray text-fz-12px">
                  あなたが入力したタイトルと説明を添削し、修正ポイントを示します。
                </p>
              </div>
              <div className="col-4 d-flex justify-content-center mx-0 px-0">
                <ReviseOutlineModal
                  originalTitle={titleText}
                  originalBody={bodyText}
                  eventId={event.id}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default SectionAiButtons;
